import { combineEpics, ofType } from 'redux-observable';
import { catchError, endWith, map,startWith,switchMap} from 'rxjs/operators';
import { of, from} from "rxjs";
import { MainReport } from "../store/model/calculations/MainReport";
import { mainReportPayload } from "../models/Myprojects";
import { downloadMainReports} from "../services/project.service";
import {  downloadMainReportSuccess, downloadMainReportFailure, setLoading } from "../store/reports/reportsSlice";


    interface DownloadMainReportAction {
        type: string;
        payload: mainReportPayload;
    }

    const loadMainReport = (action$: any) =>
        action$.pipe(
          ofType<MainReport, string>('DOWNLOAD_MAIN_REPORT'),
          switchMap((action: DownloadMainReportAction) =>
            from(downloadMainReports(action.payload)).pipe(
              map((response) => downloadMainReportSuccess(response)),
              catchError((error) => of(downloadMainReportFailure(error))),
              startWith(setLoading(true)), 
              endWith(setLoading(false))   
            )
          )
        );

export const reportEpic = combineEpics(
    loadMainReport
);

